import React, { useEffect, useState } from "react";
import { collection_activity_item_data } from "../../data/collection_data";
import Link from "next/link";
import Image from "next/image";
import { useSelector } from "react-redux";
import { ERROR } from "../../utils/errors";
import { Spin } from "antd";
import Error from "../errors/Error";
import CustomImage from "../global/CustomImage";
import { BASEURL_IMG } from "../../utils/constant";
import moment from "moment";
import { useRouter } from "next/router";
import { useCollectionActivitiesQuery } from "../../redux/actions/collection";
import { config } from "../metamask/config";
import useTranslation from "next-translate/useTranslation";

const Collection_activity_item = () => {
    const {t, lang} = useTranslation('collection')
    const { query } = useRouter();
    const loginDetails = useSelector((state) => state.counter.loginDetails);

    const [inputText, setInputText] = useState("");
    const [offset, setOffset] = useState(0);

    const { data: activitiesData, isLoading } = useCollectionActivitiesQuery({
        collectionId: query?.collection,
        text: inputText,
        offset: offset
    })

    
    const [filterVal, setFilterVal] = useState(null);
    function onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
    }

    const [data, setData] = useState(collection_activity_item_data);
    const [filterData, setfilterData] = useState(
        collection_activity_item_data.map((item) => {
            const { category } = item;
            return category;
        })
    );


    const handleFilter = (category) => {
        setData(
            collection_activity_item_data.filter((item) => item.category === category)
        );
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        const newArray = collection_activity_item_data.filter((item) => {
            return item.title.toLowerCase().includes(inputText);
        });
        setData(newArray);
        setInputText("");
    };

    useEffect(() => {
        setfilterData(filterData.filter(onlyUnique));
    }, []);
    // console.log(activities)
    return (
        <Spin spinning={isLoading} tip="Loading...">
            {/* <!-- Activity Tab --> */}
            <div className="tab-pane fade">

                {/* <!-- Records / Filter --> */}
                <div className="flex flex-col lg:flex-row">

                    {/* <!-- Records --> */}
                    <div className="mb-10 shrink-0 basis-8/12 order-2 lg:order-1 space-y-5 lg:mb-0 lg:pr-10">
                        {!isLoading && activitiesData?.data?.length === 0 ? <Error msg="There is not activity data" /> :
                            activitiesData?.data?.map((item, index) => {
                                return (
                                    <div
                                        key={item?.id}
                                        className="dark:bg-black dark:border-accent-dark border-jacarta-100 rounded-2.5xl relative flex items-center border bg-white p-8 transition-shadow hover:shadow-lg"
                                    >
                                        <figure className="mr-5 self-start">
                                            <div className="relative w-[50px] h-[50px]">
                                                <CustomImage src={`${BASEURL_IMG}${item?.localFile}`} fallback={'/images/logo.png'} loaderWidth="60" />
                                            </div>
                                        </figure>
                                        <div>
                                            <Link
                                                href={`/item/${item?.nft_id}`}>
                                                <h3 className="font-display text-jacarta-700 mb-1 text-base font-semibold dark:text-white">
                                                    {(index + 1) + (20 * (offset))}.  {item?.name}
                                                </h3>
                                            </Link>
                                            <span className="dark:text-jacarta-200 flex items-center text-jacarta-500 mb-3 text-sm">
                                                <span className="font-medium pr-1">{item?.trxType}</span> for {item?.price} <span className="inline-block pl-1 text-green text-sm uppercase font-medium">matic</span>
                                            </span>
                                            <span className="text-jacarta-300 block text-xs">
                                                Items : {item?.qty} | {moment(item?.datetime).format('ll')}
                                            </span>


                                            <span className="dark:text-jacarta-200 flex items-center text-jacarta-500 mb-3 text-sm">
                                                <span className="font-medium pr-1">
                                                    <a href={`${config.BASEURL_BLOCKCHAIN}/address/${item?.fromAddress}`} target="_blank">
                                                        From : {item?.fromAddress?.slice(0, 15)}... </a>
                                                    <a href={`${config.BASEURL_BLOCKCHAIN}/address/${item?.toAddress}`} target="_blank">
                                                        To : {item?.toAddress?.slice(0, 15)}...
                                                    </a>
                                                </span>
                                            </span>
                                            {item?.hash &&
                                                <span className="text-jacarta-300 block text-xs">
                                                    <a href={`${config.BASEURL_BLOCKCHAIN}/tx/${item?.hash}`} target="_blank">
                                                        Hash : {item?.hash?.slice(0,15)}...
                                                    </a>
                                                </span>}


                                        </div>

                                    </div>
                                );
                            })}
                    </div>

                    {/* <!-- Filters --> */}
                    <aside className="basis-4/12 lg:pl-5 order-1 lg:order-2">
                        <form
                            action="search"
                            className="relative mb-12 block"
                            onSubmit={handleSubmit}
                        >
                            <input
                                type="search"
                                className="text-jacarta-700 placeholder-jacarta-500 focus:ring-accent border-jacarta-100 w-full rounded-2xl border py-[0.6875rem] px-4 pl-10 dark:border-accent-dark dark:bg-white/[.15] dark:text-white dark:placeholder-white"
                                placeholder="Search : Type / NFT name / Wallet / Hash "
                                value={inputText}
                                onChange={(e) => setInputText(e.target.value)}
                            />
                            <button
                                type="submit"
                                className="absolute left-0 top-0 flex h-full w-12 items-center justify-center rounded-2xl"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    width="24"
                                    height="24"
                                    className="fill-jacarta-500 h-4 w-4 dark:fill-white"
                                >
                                    <path fill="none" d="M0 0h24v24H0z"></path>
                                    <path d="M18.031 16.617l4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0 1 11 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617zm-2.006-.742A6.977 6.977 0 0 0 18 11c0-3.868-3.133-7-7-7-3.868 0-7 3.132-7 7 0 3.867 3.132 7 7 7a6.977 6.977 0 0 0 4.875-1.975l.15-.15z"></path>
                                </svg>
                            </button>
                        </form>

                    </aside>
                </div>

                <div className="mt-6 py-3 px-8">
                    <div className="row">
                        <div className="col-md-4 space-x-2 flex justify-center">
                            <button disabled={offset == 0} onClick={() => setOffset(offset - 1)} className="dark:border-accent-dark/50 dark:bg-black dark:hover:bg-accent group hover:bg-accent border-jacarta-100 font-display text-jacarta-500 flex h-9 items-center rounded-lg border-2 hover:dark:border-accent-dark bg-white px-4 text-sm font-semibold transition-colors hover:border-transparent hover:text-white dark:text-white dark:hover:border-transparent dark:hover:text-white capitalize">{t('prev')}</button>

                            <button disabled={(activitiesData?.data?.length || 0) == 0} onClick={() => setOffset(offset + 1)} className="dark:border-accent-dark/50 dark:bg-black dark:hover:bg-accent group hover:bg-accent border-jacarta-100 font-display text-jacarta-500 flex h-9 items-center rounded-lg border-2 hover:dark:border-accent-dark bg-white px-4 text-sm font-semibold transition-colors hover:border-transparent hover:text-white dark:text-white dark:hover:border-transparent dark:hover:text-white capitalize">{t('next')}</button>
                        </div>
                    </div>
                </div>
            </div>
        </Spin>
    );
};

export default Collection_activity_item;
